export default {
  创作即收益: "Create. Earn. Get Paid.",
  加入EBC创作者激励计划: "Join our Creator Incentive Programme and turn your impact into income.",
  成为创作者: "Join Now",
  无限奖励: "Creator Incentive Programme",
  EBC创作者激励计划:
    "Scale your content globally to earn monthly rewards with our Creator Incentive Programme.",
  推荐奖励: "Referral Rewards",
  推荐新用户注册并交易: "Invite new users to trade & gain monthly payouts. ",
  内容变现: "Content Monetisation",
  在EBC: "Turn high-quality content into steady earnings.",
  内容进阶: "Global Exposure",
  从本地创作到全球影响: "Become our influencer to drive engagement with a global audience. ",
  预计奖金: "Estimated Monthly Reward",
  均值估算仅供参考: "*Average estimate for reference only",
  "800万交易者的信任首选": "Global Trading Platform Preferred by 5 Million Traders",
  EBC用全球最佳券商的实力:
   "As the World’s Best* Broker, we transform your influence into income and give you access to exceptional rewards and global opportunities.",
  全方位媒体曝光: "Comprehensive Media Exposure",
  我们以全球媒体资源:
    "Access FC Barcelona events and global media channels to grow your personal brand and visibility. ",
  全球最强交易环境: "Superior Trading Environment",
  打造极致交易体验:
    "Trade with millisecond execution, institutional liquidity, and excellent copy trading features.",
  专属客户经理: "Dedicated Account Manager",
  我们为每位创作者配专属运营:
    "Get one-to-one guidance to create quality content, gain support, and maximise earnings.",
  如何成为创作者: "How to Become Our Creator",
  从内容创作到奖励提现: "Get one-to-one support, every step of the way. ",
  立即加入:"Join Now",
  注册提交资料:"Register & Submit Your Details",
  发布专业内容:"Create & Share Quality EBC Content ",
  获取月度奖励:"Receive Monthly Payments",
  活动须知:"Programme Guidelines",
  notices:[
    "1. Creators must have an independent content column, social media account, or community channel, and be able to produce content consistently for at least three months. Content formats may include, but are not limited to, strategy analysis, graphic interpretations, and video courses.",
    "2. Content must remain original, professional, and compliant. In cases of plagiarism, unauthorised rewriting, or the publication of prohibited content, the platform reserves the right to revoke participation and related benefits.",
    "3. Monthly settlements will be made based on the creator’s achievement level, with rewards distributed in the first week of the following month to those who qualify.",
    "4. This programme is mutually exclusive with other programmes (such as the Copy Trading Incentive Programme or Agent Support Programme). Creators can only choose one programme at any given time.",
    `5. The platform will provide outstanding creators with dedicated
              operational support, including content assistance and conversion
              resources. For enquiries, please contact customer service or email
              <a href="mailto:mkt@ebc.com">mkt@ebc.com</a>.`,
    "6. To ensure fairness, EBC reserves the final right of interpretation for this programme and may disqualify any form of violation or abuse."
  ],
  section4Tips:"*3 Consecutive Year Recognition From World Finance: Best FX Trading Platform 2023, Best CFD Broker 2024, Best Trading Platform 2025, Most Trusted Broker 2025. Online Money Awards Best CFD Provider 2025."
};
